<template>
  <!-- 资讯列表 -->
  <div>
    <p class="total">找到{{ total }}条结果</p>
    <van-list
      v-model="loading"
      :offset="50"
      :finished="finished"
      :error="error"
      :finished-text="List.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="list-box" v-if="loading || List.length > 0">
        <ZxItem
          class="list-item"
          v-for="item in List"
          :key="item.id"
          :title="item.title"
          :img="item.other.cover"
          :creatTime="item.releaseTime | dateFormat"
          :number="item.readPv"
          :author="item.periodical"
          @click.native="toDetail(item.id)"
        />
      </div>
      <noneList noneType="search" v-else />
    </van-list>
  </div>
</template>

<script>
import ZxItem from "@/views/mobileView/components/listItem/zxItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "Zx",
  components: { ZxItem, noneList },
  data() {
    return {
      Params: {
        pageNo: 0,
        pageSize: 20,
        queryParam: {
          configMap: {
            must: [
              {
                esField: "all",
                queryValue: this.$route.query.paramStr,
              },
              {
                esField: "articleType",
                queryValue: [5],
              },
            ],
          },
          otherQueryParams: {
            platformId: 1,
          },
        },
      },
      List: [],
      total: 0,
      loading: false,
      finished: false,
      error: false,
    };
  },
  filters: {
    // 时间格式化
    dateFormat(o) {
      if (o) {
        const dt = new Date(Number(o));
        const m = (dt.getMonth() + 1 + "").padStart(2, "0");
        const d = (dt.getDate() + "").padStart(2, "0");
        return `${m}-${d}`;
      } else {
        return "";
      }
    },
  },
  methods: {
    // 触底加载
    onLoad() {
      this.Params.pageNo += 1;
      this.getSearchList();
    },
    // 获取资讯列表
    async getSearchList(data) {
      const resp = await this.$apis.searchServe.getEsList(this.Params);
      if (resp.resultCode == 200) {
        this.finished = resp.data.list.length < 20;
        this.List.push(...resp.data.list);
        this.total = +resp.data.total;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 资讯跳转详情
    toDetail(id) {
      this.$router.push({
        name: "msgDetails",
        query: {
          id,
          type: 5,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.total {
  text-align: center;
  font-size: 13px;
  color: #999999;
  line-height: 19px;
}
.list-box {
  margin-top: 15px;
  padding: 0 12px;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  .list-item {
    border-bottom: 1px solid #eee;
  }
}
</style>
